// extracted by mini-css-extract-plugin
module.exports = {"navBar":"DxLTqh","left":"_3cOlTI","logo":"_3W9j25","right":"_1JajkV","newWebsite":"_2mtzJh","userDp":"_2_Rp7m","logout":"_3R6yJZ"};